import { render, staticRenderFns } from "./YouTubeCallback.vue?vue&type=template&id=2388694e&scoped=true&"
import script from "./YouTubeCallback.vue?vue&type=script&lang=js&"
export * from "./YouTubeCallback.vue?vue&type=script&lang=js&"
import style0 from "./YouTubeCallback.vue?vue&type=style&index=0&id=2388694e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2388694e",
  null
  
)

export default component.exports